module.exports = __webpack_public_path__ + "static/media/home.23ee243d.svg";